import { Component, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { LoginService } from "../../services/login.service";
import { Router } from "@angular/router";
import { AppStateService } from "../../services/appState.service";
import { ModalService } from "app/allgemeinesTS_CSS/_modal";

// Validatoren
function emailValidator(control: FormControl) {
  const valid = control.value
    .toLowerCase()
    .match(
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
    );
  return valid ? null : { invalidEmail: true };
}
function equalValidator({ value }: FormGroup): { [key: string]: any } {
  const [first, ...rest] = Object.keys(value || {});
  const valid = rest.every((v) => value[v] === value[first]);
  return valid ? null : { equal: true };
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css", "../../allgemeinesTS_CSS/cssButton.css"],
  providers: [LoginService],
})
export class LoginComponent implements OnInit {
  protected loginForm: FormGroup;
  protected submitPressed: boolean;
  public appStatus: Object = {};
  public email = "";
  public confirmation = "";
  public disclaimerAccepted = false;
  private waitToSetSubmitPressed: any;
  constructor(
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private appStateService: AppStateService,
    private modalService: ModalService
  ) {}
  ngOnInit() {
    this.appStateService.appStatus$.subscribe((res) => {
      this.appStatus = res;
    });
    this.loginForm = this.fb.group({
      loginData: this.fb.group(
        {
          email: ["", [Validators.required, emailValidator]],
          confirmation: ["", [Validators.required, emailValidator]],
        },
        { validator: equalValidator }
      ),
      disclaimerAccepted: ["", Validators.requiredTrue],
    });
    this.loginService.checkForLogin().then((res) => this.checkLogin(res));
    const server: string = window.location.href.split("/")[2];
    if (
      server === "127.0.0.1" ||
      server === "localhost" ||
      server === "oplc.cranimax"
    ) {
      this.email = "Gast@Bauma.de";
      this.confirmation = "Gast@Bauma.de";
    } else if (server === "executor") {
      this.email = "test@executor.de";
      this.confirmation = "test@executor.de";
    }
  }
  checkLogin(res: any) {
    if (res["loginStatus"] === "loggedIn") {
      this.appStateService.appStatusVonServerHolen().then(() =>
        this.appStateService.appStatusSetzen({
          aktuellerMenuePunkt: "Login",
          PrintOut: "inactive",
        })
      );
    } else {
      localStorage.clear();
      let neuerStatus: Object;
      neuerStatus = {
        loginStatus: "loggedOff",
        Login: "active",
        CraneSelection: "inactive",
        CraneSetup: "inactive",
        CraneControl: "inactive",
        PrintOut: "inactive",
        aktuellerMenuePunkt: "Login",
      };
      this.appStateService.appStatusSetzen(neuerStatus);
    }
    this.speichere("Version", res["LiftplanVersion"]);
  }
  logOff() {
    this.loginService.doLogout().then((res) => this.doLogout(res));
  }
  doLogout(res) {
    if (res["status"] === "loggedOff") {
      localStorage.removeItem("email");
      this.appStateService.kranGewaehltNeu({});
      this.appStateService.appStatusReset({
        loginStatus: "loggedOff",
        Login: "inactive",
        CraneSelection: "inactive",
        CraneSetup: "inactive",
        CraneControl: "inactive",
        PrintOut: "inactive",
      });
      this.appStateService.aktuellerMenuepunktSetzen("Login");
    }
  }
  onSubmit() {
    this.waitToSetSubmitPressed = setTimeout(() => {
      this.submitPressed = true;
    }, 500);
    if (this.loginForm.valid) {
      this.loginService.doLogin(this.email, this.confirmation).then((res) => {
        this.login(res["result"], this.email, res["timeout"]);
      });
    }
  }

  login(result: string, email: string, timeout: string) {
    this.appStatus["loginStatus"] = result;
    if (this.appStatus["loginStatus"] === "loggedIn") {
      clearInterval(this.waitToSetSubmitPressed);
      const menueStartStatus: Object = {
        CraneSelection: "active",
      };
      this.appStateService.aktuellerAppStatus["EMail"] = email;
      this.appStateService.meuePunktStatusSetzen(menueStartStatus);
      this.router.navigate(["/craneSelection"]);
    }
  }
  speichere(was, wert) {
    localStorage.setItem(was, wert);
  }
  openModal(id: string) {
    this.modalService.open(id);
    return false;
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }
  disclaimerAcceptedClicked() {
    this.submitPressed = false;
    return true;
  }
}
